<template>
  <wordmap :data="[data]" v-bind="$attrs" />
</template>

<script>
import Wordmap from '@/components/maps/Wordmap.vue';
import { loadSingleWordData } from '@/services/mapdata';

export default {
  data() {
    return {
      data: null,
    }
  },
  props: {
    url: {
      type: String,
      required: true,
    },
  },
  components: {
    Wordmap,
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.data = await loadSingleWordData(this.url)
    }
  },
}
</script>